import DataTable from 'components/organisms/data-table'
import InternalRequestTableColumns from './internal-request-table-columns'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'


const propTypes = {
  categoryStatus : PropTypes.object,
  data           : PropTypes.array,
  pagination     : PropTypes.object,
  onFetchData    : PropTypes.func,
  isLoading      : PropTypes.bool,
  rowButtonProps : PropTypes.shape({
    buttonText       : PropTypes.string,
    buttonColour     : PropTypes.string,
    isButtonDisabled : PropTypes.func,
    onButtonClick    : PropTypes.func
  }),
  hiddenColumns: PropTypes.arrayOf(PropTypes.string)
}

const defaultProps = {
  isLoading      : false,
  rowButtonProps : {
    buttonText       : '',
    buttonColour     : '',
    isButtonDisabled : () => {},
    onButtonClick    : () => {}
  }
}

/**
 * Domain-specifc DataTable for Internal Request
 * @param {object} categoryStatus - category of Internal Request status (reqest, ongoing, archive)
 * @param {object[]} data - array of seller_inbound objects
 * @param {object} pagination - object of pagination data from endpoint
 * @param {func} onFetchData - function that will call endpoint for data
 * @param {object} rowButtonProps - Button Props for row button
 * @param {Boolean} isLoading - whether the table is currently loading data from the backend
 * @param {array} hiddenColumns - Hide specific columns by id
 */
const InternalRequestTable = ({
  categoryStatus,
  data,
  pagination,
  onFetchData,
  rowButtonProps,
  hiddenColumns,
  isLoading
}) => {

  /**
   * It's important that we're using React.useMemo
   * here to ensure that our data isn't recreated on every render.
   * see https://react-table.tanstack.com/docs/quick-start
   *
   * we destruct rowButtonProps to make sure this object only render once
   *  */
  const {
    onButtonClick,
    buttonText,
    buttonColour,
    isButtonDisabled
  } = rowButtonProps

  const columns = useMemo(
    () => InternalRequestTableColumns({
      categoryStatus,
      onButtonClick,
      buttonText,
      buttonColour,
      isButtonDisabled
    }),
    [
      buttonText,
      buttonColour,
      isButtonDisabled,
      categoryStatus,
      onButtonClick
    ]
  )

  return (
    <DataTable
      data={ data }
      columns={ columns }
      pagination={ pagination }
      onFetchData={ onFetchData }
      isLoading={ isLoading }
      hiddenColumns={ hiddenColumns }
    />
  )
}

InternalRequestTable.propTypes    = propTypes
InternalRequestTable.defaultProps = defaultProps

export default InternalRequestTable
